module.exports = require("./lodash.js");


//////////////////
// WEBPACK FOOTER
// lodash (bower component)
// module id = 413
// module chunks = 1